module.exports = __webpack_public_path__ + "static/media/Resume.f108cc4a.pdf";